module.exports = __webpack_public_path__ + "img/vertical_3_4_3.f3d95d9d.png";